import React, {Component} from 'react';
import {connect} from 'react-redux';
import SolicitorGroupsList from "../../components/SolicitorGroups/solicitorGroupsList";
import {
    receiveSolicitorGroups,
    requestGetSolicitorGroups, requestGetSolicitorGroupsSuggestions, requestGetUnderwriters,
    requestGetWorkSources
} from "../../actions/solicitorGroup";
import { push } from 'connected-react-router';
import {changeSolicitorGroupListSettings, solicitorGroupPageShift} from "../../actions/solicitorGroupList";


class SolicitorGroupListHOC extends Component {
    constructor(props){
        super(props);
        let askServer;
    }
    componentWillMount() {
        const parameters = this.getRequestParameters(this.props);
        this.askServer = setTimeout(()=>{this.props.requestGetSolicitorGroups(parameters)},0);
        // this.props.requestGetSolicitorGroups(parameters);
        // this.props.getUnderwriters();
        // this.props.getWorkSources();
    };

    componentWillReceiveProps(nextProps) {
        clearTimeout(this.askServer);
        if(
            this.props.solicitorGroupsList.selectedView !== nextProps.solicitorGroupsList.selectedView ||
            this.props.solicitorGroupsList.value !== nextProps.solicitorGroupsList.value ||
            this.props.solicitorGroupsList.page !== nextProps.solicitorGroupsList.page
        ) {
            const parameters = this.getRequestParameters(nextProps);
            if(this.props.solicitorGroupsList.value!==nextProps.solicitorGroupsList.value && nextProps.solicitorGroupsList.value!==''){
                parameters.limit = 5;
                parameters.offset = 0;
                this.askServer = setTimeout(()=>{this.props.requestGetSolicitorGroupsSuggestions(parameters)},150);
            } else {
                this.props.requestGetSolicitorGroups(parameters);
            }
        }
    }

    getRequestParameters = (props) => {
        const calcOffset = props.solicitorGroupsList.selectedView * (props.solicitorGroupsList.page -1);
        const parameters = {
            limit: props.solicitorGroupsList.selectedView,
            offset: calcOffset>0? calcOffset:0,
            search: props.solicitorGroupsList.value === '' ? null : props.solicitorGroupsList.value,
        };
        return parameters;
    };

    getUnderwriterName = (underwriterId) => {
        let underwriters = this.props.solicitorGroupsList.underwriters;
        for (let i = 0; i < underwriters.length; i++) {
            if (underwriters[i].id === parseInt(underwriterId)) {
                return underwriters[i].name
            }
        }
    };

    getWorkSourceName = (workSourceId) => {
        let workSources = this.props.solicitorGroupsList.workSources;
        for (let i = 0; i < workSources.length; i++) {
            if (workSources[i].id === parseInt(workSourceId)) {
                return workSources[i].name
            }
        }
    };

    calculateFeaturedGroups = () => {
        let solicitorGroups = this.props.solicitorGroupsList.solicitorGroups;
        let page = this.props.solicitorGroupsList.page;
        let selectedView = parseInt(this.props.solicitorGroupsList.selectedView);
        let suggestions = this.props.solicitorGroupsList.selectedSuggestions;

        let featuredGroups = [];
        let totalGroups = solicitorGroups.length;

        featuredGroups = [...solicitorGroups];
        if (suggestions.length > 0) {  //display suggestions
            featuredGroups = suggestions;
        }
        //calculation of the applications per page
        let start = (page - 1) * selectedView;
        let end = start + selectedView;
        let featuredGroupsPerPage = featuredGroups.slice(start, end);

        return [featuredGroupsPerPage, featuredGroups.length];
    };

    onSuggestionsClearRequested = () => {
        if (this.props.solicitorGroupsList.value === '') {
            this.props.changeSolicitorGroupListSettings('suggestions', []);
        }
    };

    onSuggestionsFetchRequested = ({value}) => {
        this.props.changeSolicitorGroupListSettings('suggestions', this.getSuggestions(value))
    };


    calculateIfSolicitorsExist = (group, inputValue) => {
        let solicitors = group.solicitors;
        for(let i = 0; i < solicitors.length; i++){
            if(solicitors[i].lawsysFirm.toLowerCase().includes(inputValue)){
                return true
            }
        }
        return false
    };

    calculateIfWorksourceExists = (group, inputValue) => {
        let workSource = group.workSource;
        for(let i = 0; i < workSource.length; i++){
            if(this.getWorkSourceName(workSource[i]).toLowerCase().includes(inputValue)){
                return true
            }
        }
        return false
    };

    getSuggestions = value => {
        return this.props.solicitorGroupsList.suggestions;

    };

    getSuggestionValue = suggestion => suggestion.name;

    renderSuggestion = suggestion => (
        <div>
            {suggestion.name!== ''? suggestion.name:''}
        </div>
    );

    onChange = (event, {newValue}) => {
        event.preventDefault();
        this.props.changeSolicitorGroupListSettings('value', newValue);
        if (newValue === '') {
            this.props.changeSolicitorGroupListSettings('selectedSuggestions', this.props.solicitorGroupsList.solicitorGroups);
        }
    };

    onGroupSuggestionSelected = (event, {suggestion, suggestionValue, suggestionIndex, sectionIndex, method}) => {
        if ( ( method === 'click' || (method === 'enter') ) && suggestion ) {
            let payload = {
                data: [suggestion],
                limit:0,
                offset:0,
                totalRecords: 1
            };
            this.props.receiveSolicitorGroups(payload);
        }
    };

    handleAutosuggestButton = () => {
        const parameters = this.getRequestParameters(this.props);
        this.props.requestGetSolicitorGroups(parameters);
    };

    _handleSolGroupRowClick = (evt, group) => {
        this.props.changeSolicitorGroupListSettings('selectedGroup', group);
    };

    render() {
        let value = this.props.solicitorGroupsList.value;
        const inputProps = {
            placeholder: '',
            value,
            onChange: this.onChange
        };

        return (
            <SolicitorGroupsList
                requestGetSolicitorGroups={this.props.requestGetSolicitorGroups}
                _handleSolGroupRowClick={this._handleSolGroupRowClick}
                handleAutosuggestButton={this.handleAutosuggestButton}
                onSuggestionSelected={this.onGroupSuggestionSelected}
                suggestions={this.props.solicitorGroupsList.suggestions}
                getSuggestionValue={this.getSuggestionValue}
                renderSuggestion={this.renderSuggestion}
                onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
                onSuggestionsClearRequested={this.onSuggestionsClearRequested}
                inputProps={inputProps}
                calculateFeaturedGroups={this.calculateFeaturedGroups}
                pageShift={this.props.solicitorGroupPageShift}
                changeSolicitorGroupListSettings={this.props.changeSolicitorGroupListSettings}
                push={this.props.push}
                getUnderwriterName={this.getUnderwriterName}
                getWorkSourceName={this.getWorkSourceName}
                store={this.props.solicitorGroupsList}
            />
        )
    }
}

const mapStateToProps = (state) => {
    return {
        solicitorGroupsList: state.solicitorGroupsList
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        requestGetSolicitorGroups: (payload) => {
            dispatch(requestGetSolicitorGroups(payload))
        },
        requestGetSolicitorGroupsSuggestions: (payload) => {
            dispatch(requestGetSolicitorGroupsSuggestions(payload))
        },
        getUnderwriters: () => {
            dispatch(requestGetUnderwriters())
        },
        getWorkSources: () => {
            dispatch(requestGetWorkSources())
        },
        push: (path) => {
            dispatch(push(path))
        },
        changeSolicitorGroupListSettings: (key, value) => {
            dispatch(changeSolicitorGroupListSettings(key, value))
        },
        solicitorGroupPageShift: (direction, totalPaginationBoxes) => {
            dispatch(solicitorGroupPageShift(direction, totalPaginationBoxes))
        },
        receiveSolicitorGroups: (payload) => {
            dispatch(receiveSolicitorGroups(payload))
        }
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(SolicitorGroupListHOC);
